import { queryOptions } from '@tanstack/react-query';
import { IGetOtherCostsQueryParams } from './getOtherCostsQuery.types';
import { getOtherCostsFunction } from './getOtherCostsQueryFunction';

export const getOtherCostsQueryOptions = (
  params: IGetOtherCostsQueryParams,
) => {
  return queryOptions({
    queryKey: ['other-costs', params],
    queryFn: () => getOtherCostsFunction(params),
  });
};
